import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { shardRepositoryActions } from "redux/actions/shard-repository";
import { IAppState } from "redux/reducers";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import styles from "./update-confirmation.module.scss";

const mapDispatchToProps = (
    dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeUpdateConfirmation: () => {
      dispatch(shardRepositoryActions.updateConfirmation.close());
    }
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.shardRepository.updateConfirmation.isOpen,
  data: state.shardRepository.updateConfirmation.data,
});

export interface IUpdateConfirmationProps extends
    ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {

  onUpdate: () => void;
  onCancel: () => void;
}

export const UpdateConfirmation = connect(mapStateToProps, mapDispatchToProps)((props: IUpdateConfirmationProps) => {
  function handleConfirm() {
    props.onUpdate();
    props.closeUpdateConfirmation();
  }

  function handleCancel() {
    props.onCancel();
    props.closeUpdateConfirmation();
  }

  return (
      <ConfirmDialog
          testId="update-node-confirmation"
          title="Update Shard Repository"
          confirmText="Confirm"
          open={props.isOpen}
          onClose={props.closeUpdateConfirmation}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
      >
        <div className={styles.content}>
          Are you sure you want to update shard repository?

          {!!props.data
              ?
              <section className={styles.fields}>
                {Object.keys(props.data.updatedFields).map(fieldName => {
                  return (
                    <section
                        className={styles["field-description"]}
                        key={fieldName}
                    >
                      <div className={styles["field-caption"]}>{fieldName}:</div>
                      <div>{props.data.originalNode[fieldName]}</div>

                      {props.data.originalNode[fieldName]
                          ? <div>&rarr;</div>
                          : <div></div>
                      }

                      <div>{props.data.updatedFields[fieldName]}</div>
                    </section>
                  )
                })}
              </section>
              :
              <></>
          }
        </div>
      </ConfirmDialog>
  );
});
